<template>
    <div id="app">
        <header v-if="$route.name === 'Home'">
            <div class="tw-container tw-flex tw-items-center tw-justify-center lg:tw-justify-between tw-py-4">
                <div>
                    <img src="~@/assets/img/logo.svg">
                </div>
                <div class="tw-hidden lg:tw-flex tw-flex-col lg:tw-flex-row tw-items-end lg:tw-items-center tw-justify-end tw-gap-2 lg:tw-gap-5">
                    <!-- <p class="tw-font-bold">Exclusivo para empresas</p> -->
                </div>
            </div>
            <div class="tw-block lg:tw-hidden">
                <!-- <p class="tw-font-bold tw-block tw-mx-auto tw-text-center">Exclusivo para empresas</p> -->
            </div>
        </header>

        <!-- This will be reaplced by the view defined in the router -->
        <router-view></router-view>

        <footer v-if="$route.name === 'Home'">
            <div class="tw-container">
                <img src="@/assets/img/logo-footer.svg">
            </div>
        </footer>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <Clarity/>

        <KwPixel v-if="$store.state.formSuccess"/>
    </div>
</template>

<script>
import axios from 'axios';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Clarity from '@/components/Clarity.vue';

export default {
    components: {
        KwPixel,
        Clarity,
        ModalContainer,
        Terms,
    },
    created() {
        const data = {
            url: window.location.hostname,
            pubid: this.$route.query.pubid || null,
            utm_source: this.$route.query.utm_source || null,
            utm_campaign: this.$route.query.utm_campaign || null,
            utm_medium: this.$route.query.utm_medium || null,
            utm_content: this.$route.query.utm_content || null,
            utm_term: this.$route.query.utm_term || null,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => {
                console.log(error.response.data);
            });
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
    },
};
</script>
<style>

</style>
